'use client';

import { type ReactNode } from 'react';

// Matches the camera view's height so the frame doesn't jump between states
export const RECORDED_VIDEO_PLAYER_CLASS = 'h-64 w-full rounded-none border-0 md:h-80 lg:h-96';

type VideoContainerProps = {
	children: ReactNode;
	badge?: ReactNode;
	overlay?: ReactNode;
};

export function VideoContainer({ children, badge, overlay }: VideoContainerProps) {
	return (
		<div className="relative overflow-hidden rounded-lg bg-black opacity-100 transition-all duration-500">
			{children}
			{badge && <div className="absolute left-2 top-2 flex items-center gap-2">{badge}</div>}
			{overlay && (
				<div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 items-center justify-center">
					{overlay}
				</div>
			)}
		</div>
	);
}

